import React from "react";
import { SimpleGrid, Stack, Text } from "@chakra-ui/react";
import { BarList, ChartCard } from "./parts";
import Heatmap from "./Heatmap";
import { useVizTokens } from "./tokens";
import { WEEKDAYS, count, hourWords, money } from "./format";

// When texting costs: by hour of each weekday, the busiest hours, and each weekday's total.
export default function WhenPanel({ report }) {
  const t = useVizTokens();
  const cells = report.heatmap || [];
  const busiest = [...cells].sort((a, b) => b.cost - a.cost).slice(0, 5).map((c) => ({
    key: `${c.day}:${c.hour}`,
    label: `${WEEKDAYS[c.day]} ${hourWords(c.hour)}`,
    value: c.cost,
    valueLabel: money(c.cost),
    sub: `${count(c.texts)} texts`,
  }));
  const byDay = WEEKDAYS.map((name, day) => {
    const own = cells.filter((c) => c.day === day);
    const cost = own.reduce((s, c) => s + c.cost, 0);
    const texts = own.reduce((s, c) => s + c.texts, 0);
    return { key: name, label: name, value: cost, valueLabel: money(cost), sub: `${count(texts)} texts` };
  });
  return (
    <Stack spacing={4}>
      <ChartCard title="When texting costs"
                 subtitle={`Each hour of each weekday, ${report.range.timezone === "America/Los_Angeles"
                   ? "Pacific" : report.range.timezone.replace(/_/g, " ")} time`}
                 table={{
                   columns: [
                     { key: "day", label: "Day", render: (r) => WEEKDAYS[r.day] },
                     { key: "hour", label: "Hour", render: (r) => hourWords(r.hour) },
                     { key: "texts", label: "Texts", numeric: true, render: (r) => count(r.texts) },
                     { key: "cost", label: "Cost", numeric: true, render: (r) => money(r.cost) },
                   ],
                   rows: cells.map((c) => ({ ...c, key: `${c.day}:${c.hour}` })),
                 }}>
        <Heatmap cells={cells} />
      </ChartCard>
      <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={4}>
        <ChartCard title="Costliest hours">
          <BarList rows={busiest} />
          <Text fontSize="xs" color={t.muted} mt={3}>
            A sharp column at one hour every day is usually an automatic send (reminders, confirmations).
          </Text>
        </ChartCard>
        <ChartCard title="By weekday">
          <BarList rows={byDay} />
        </ChartCard>
      </SimpleGrid>
    </Stack>
  );
}
